import { Component,} from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Subscription } from 'rxjs/Subscription'
import { Title } from '@angular/platform-browser';
import { Router,  ActivatedRoute } from '@angular/router';
import { HttpHeaders} from "@angular/common/http";
import { ApiService } from '../services/api.service';
import { User,QueryStringParameter,  DynamicPage} from '../models/data.types';
import { DynamicPageDirective } from '../directives/index';

@Component({
  selector: 'pg',
  template: `<div #dynamicPage></div>`
})
export class DynamicPageComponent {

  constructor(
    private route: ActivatedRoute,
    private apiService: ApiService,
    private titleService: Title) {  }

    sub: any;
    page: DynamicPage = new DynamicPage();
    pageTitle : string = "";
    
  LoadDynamicPage(pageName : String ,dynamicPageDirective : DynamicPageDirective, isMainPage: boolean) : Promise<string>
  {
    let currentUser : User;
    currentUser = JSON.parse(localStorage.getItem('currentUser'));
    
    if (currentUser != null) {

      this.apiService.authHeaders = new HttpHeaders();
      this.apiService.authHeaders.append('Content-Type', 'application/json');
      this.apiService.authHeaders.append(
        'Authorization', 'bearer ' + currentUser.token
      );
    }

    return this.apiService.get<DynamicPage>('pages/getpagebyroute/' + pageName).then(response => {
   
      Observable.combineLatest(this.route.params, this.route.queryParams, 
        (params, qparams) => ({ params, qparams })).subscribe( ap =>   { 
      
          if (this.page != null ){
            
            let queryStringparams: QueryStringParameter[] = [];

            let pArray = Reflect.ownKeys(ap.qparams);

            pArray.forEach(element => {
              let qsp = new QueryStringParameter();
              qsp.Name = element.toString();
              qsp.Value = Reflect.get(ap.qparams, element.toString());
              queryStringparams.push(qsp);
            });

            this.page = response;

            if(isMainPage)
            {              
                this.pageTitle =this.page.Title != null  ?  this.page.Title : this.page.Name;
                this.titleService.setTitle(this.pageTitle);
            }

            dynamicPageDirective.addComponent(this.page,queryStringparams,isMainPage);

          

            if(queryStringparams.find(x => x.Name == "portal" || x.Name == "title") == null)
            {
              this.page = null;
            }
          }
          else if (response.Name === "AppshellSupport") {
            
            
            dynamicPageDirective.addComponent(response,null,false);

          }
      });

      

     return this.pageTitle;

     
      }).catch(e => {
        if (e.status === 401) {
            //  this.router.navigate(['/page/login']);
            console.log(e);

            this.apiService.get<DynamicPage>('pages/getpagebyroute/401').
            then(response => {
              dynamicPageDirective.addComponent(response,null,false);
            });

            
            return "";
          }
          else
          {
            return "404";
          }
       
      });
    
    };

}



// WEBPACK FOOTER //
// ./src/app/helpers/dynamicPage.ts